// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-3d2-d"};